import React, { Component, Fragment } from 'react';
import YoutubeEmbedVideo from 'react-youtube-embed';
import Config from '../../../site-config';
import { Container, Box, Title } from './videos.css';
import axios from 'axios';
import Carousel from 'nuka-carousel';
import LazyLoad from 'react-lazyload';
import YoutubeId from 'get-youtube-id';

class Videos extends Component {
  constructor() {
    super();

    this.state = {
      activeIndex: [],
      videos: [],
      hasLoaded: false,
    };
  }

  componentDidMount() {
    this.getVideos();
  }

  getVideos = async () => {
    const videos = await axios.get(
      `https://cdn.contentful.com/spaces/${
        Config.contentFul.spaceId
      }/environments/master/entries/?access_token=${
        Config.contentFul.access_token
      }&content_type=videoList`
    );

    const orderedIds = videos.data.items[0].fields.videos.map(
      entry => entry.sys.id
    );
    const cleanVideos = orderedIds.map(ID => {
      const v = videos.data.includes.Entry.find(vid => vid.sys.id === ID);
      return {
        title: v.fields.videoTitle,
        youtubeUrl: v.fields.youtubeUrl,
      };
    });

    this.setState({
      hasLoaded: true,
      videos: cleanVideos,
    });
  };

  handleClick = id =>
    this.setState({
      activeIndex: id,
    });

  render() {
    const { videos, hasLoaded } = this.state;

    if (!hasLoaded) return null;

    return (
      <Fragment>
        <Title>Videos</Title>
        <LazyLoad offset={600} once>
          {videos.length && (
            <Container name="videos">
              <Carousel
                wrapAround={true}
                width="100%"
                style={{ marginTop: '20px' }}
                cellAlign="center"
                renderBottomCenterControls={() => null}
              >
                {videos.map(vid => {
                  const youtubeId = YoutubeId(vid.youtubeUrl);

                  return (
                    <Box key={youtubeId}>
                      <YoutubeEmbedVideo id={youtubeId} suggestions={false} />
                    </Box>
                  );
                })}
              </Carousel>
            </Container>
          )}
        </LazyLoad>
      </Fragment>
    );
  }
}

export default Videos;
